// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"613":"44ba64d6","737":"82999807","983":"9e97ce63"}[chunkId] + ".chunk.js";
};